import { Analytics } from '@cobliteam/analytics';

import {
  BodyText,
  CaptionDefault,
  DescriptionTitle,
  Switch,
  Tooltip,
} from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import * as styles from '../../styles';

interface MapMatchProps {
  mapMatchActive: boolean;
  handleToggleMapMatch: () => void;
}

const MapMatch = ({ mapMatchActive, handleToggleMapMatch }: MapMatchProps) => {
  const handleCtaMapMatchClick = () => {
    Analytics.track('Know More About Map Match Clicked', {
      origin: 'tracking page toggle tooltip map match',
    });

    window.open(
      'https://suporte.cobli.co/como-funciona-a-configura%C3%A7%C3%A3o-de-ajus?hs_preview=ZtAODARM-118192092066'
    );
  };

  return (
    <div className={styles.toggle}>
      <Switch
        name="MapMatchSwitch"
        onChange={handleToggleMapMatch}
        checked={mapMatchActive}
      />

      <div className={styles.textWithTooltipWrapper}>
        <CaptionDefault className={styles.text}>
          Ajuste de trajetos
        </CaptionDefault>

        <Tooltip arrow placement="top" className={styles.tooltip}>
          <DescriptionTitle className={styles.tooltipTitle}>
            Ajuste de trajetos
          </DescriptionTitle>
          <BodyText className={styles.tooltipBody}>
            Melhora a visualização dos trajetos próximos às vias do mapa.
            Desativar pode ajudar em análises de eventos fora das vias, em
            indústrias, fazendas e estacionamentos.
          </BodyText>
          <Button variant="text" onClick={handleCtaMapMatchClick}>
            Entenda como funciona
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default MapMatch;
